// extracted by mini-css-extract-plugin
module.exports = {"banner":"_9efb403","sportsMaintenance":"_3c768ec","logo":"_6e62560","messageContainer":"_611766c","title":"_9420777","subTitle":"_e91f8db"};